import _ from 'lodash';
import CacheableDataObject from './CacheableDataObject';
import Transaction from "./Transaction.jsx";
import Budget from "./Budget.jsx";

/**
 * Always has the same category as its children
 */
export default class MultiBudget extends CacheableDataObject {

	hasActivity() {
		if(this.getBudgeted() !== 0) {
			return true;
		}
		if(this.getTransactions().length > 0) {
			return true;
		}
		return false;
	}

	get year() {
		throw new Error('this is not right');

	}

	get month() {
		throw new Error('this is not right');
	}

	/**
	 *
	 * @returns {moment[]}
	 */
	get date() {
		const dates = [];
		_.each(this.budgets, (budget) => {
			dates.push(budget.date);
		});
		return dates;
	}

	setBudgets(budgets) {
		this.budgets = budgets;
	}

	get category() {
		return this.budgets[0].category;
	}

	getTransactions() {
		const transactions = [];
		_.each(this.budgets, (budget) => {
			transactions.push(...budget.category.getTransactionsForBudget(budget));
		});
		transactions.sort(Transaction.transactionSort);
		return transactions;
	}

	getTransactionsForBudgetIncludingChildren() {
		const transactions = [];
		_.each(this.budgets, (budget) => {
			transactions.push(...budget.getTransactionsForBudgetIncludingChildren(budget.category));
		});
		transactions.sort(Transaction.transactionSort);
		return transactions;
	}

	/**
	 *
	 * @returns {Array} - Mixed list of Transactions and TransactionSplits
	 */
	getTransactionsFilterDownToSplits(filterDate, filterBy) {
		const transactionList = [];
		this.getTransactions().forEach((transaction) => {
			if(filterDate && filterBy) {
				if(!transaction.transaction_date.isSame(filterDate, filterBy)) {
					return;
				}
			}
			if(transaction.isSplit()) {
				for(let split of transaction.splits) {
					if(split.category_id === this.category.id) {
						transactionList.push(split);
					}
				}
			}
			else {
				transactionList.push(transaction);
			}
		});
		return transactionList;
	}

	contains(budget) {
		for(const childBudget of this.budgets) {
			if(childBudget.contains(budget)) {
				return true;
			}
		}
		return false;
	}

	isRolloverStart() {
		return false;
	}

	isRolloverEnd() {
		return false;
	}

	get amount(){
		let total = 0;
		_.each(this.budgets, (budget) => {
			total += budget.amount;
		});
		return total;
	}

	getBudgeted() {
		let total = 0;
		_.each(this.budgets, (budget) => {
			total += budget.getBudgeted();
		});
		return total;
	}

	getSpent(filterDate, filterBy) {
		const transactions = this.getTransactionsFilterDownToSplits(filterDate, filterBy);
		let total = 0;
		transactions.forEach((transaction) => {
			total += transaction.amount;
		});
		return total;
	}

	getRemaining() {
		let total = 0;
		_.each(this.budgets, (budget) => {
			total += budget.getRemaining();
		});
		return total;
	}

	getFundTotal() {
		let total = 0;
		_.each(this.budgets, (budget) => {
			total += Number(budget.fund_total);
		});
		return total;
	}

	getMinimumPayment() {
		let total = 0;
		_.each(this.budgets, (budget) => {
			total += budget.minimum_payment;
		});
		return total;
	}

	hasChanges() {
		return false;
	}
}
MultiBudget.prototype.isMultiBudget = true;